import React, { lazy } from "react";
import Icon from "@mui/material/Icon";
import { LocalOffer, Article } from "@mui/icons-material";

const OnTheFly = lazy(() => import("./contents/offers/on-the-fly"));
const Faq = lazy(() => import("./contents/help-contact/help/faq"));
const ContactUs = lazy(() => import("./contents/help-contact/contact/contact-us"));

const routes = [
  {
    name: "Offers",
    nameKey: "nav:navbar.offers",
    icon: <LocalOffer />,
    route: "offers/on-the-fly",
    component: <OnTheFly />,
  },
  {
    name: "Blog",
    nameKey: "nav:navbar.blog",
    icon: <Article />,
    route: "blog",
  },
  {
    name: "Help & Contact",
    nameKey: "nav:navbar.helpContact",
    icon: <Icon>help</Icon>,
    columns: 1,
    rowsPerColumn: 2,
    collapse: [
      {
        name: "Help",
        nameKey: "nav:navbar.help",
        collapse: [
          {
            name: "FAQ",
            nameKey: "nav:navbar.faq",
            route: "help-contact/help/faq",
            component: <Faq />,
          },
        ],
      },
      {
        name: "Contact",
        nameKey: "nav:navbar.contact",
        collapse: [
          {
            name: "contact us",
            nameKey: "nav:navbar.contactUs",
            route: "help-contact/contact/contact-us",
            component: <ContactUs />,
          },
        ],
      },
    ],
  },
];

export default routes;
